import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useComponentVisible } from '../hooks';

const Wrapper = styled.div`
  position: relative;
  .dropdown-menu.show {
    min-width: -webkit-fill-available !important;
  }
`;

const DropdownButton = ({ title, className, style, children, disabled }) => {
  const { ref, isComponentVisible } = useComponentVisible(false, false, '', disabled);
  // const [expand, setExpand] = React.useState(false);
  return (
    <Wrapper className="items-wrapper" style={style}>
      <button
        ref={ref}
        type="button"
        className={`${className} dropdown-toggle`}
        disabled={disabled}
      >
        <span className="">{title}</span>
      </button>
      <div className={`dropdown-menu dropdown-menu-left ${isComponentVisible ? ' show' : ''}`}>
        {children}
      </div>
    </Wrapper>
  );
};

DropdownButton.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
  style: PropTypes.instanceOf(Object),
  children: PropTypes.node.isRequired
};

DropdownButton.defaultProps = {
  title: '',
  className: 'btn',
  style: {}
};

export default DropdownButton;
